import useExperiment from 'hooks/Optimizely/useExperiment'
import { Experiments } from 'constants/optimizely'
import { useAppSelector } from 'hooks/reduxHooks'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'
import getHasLoyaltyAccount from 'loyalty/selectors/getHasLoyaltyAccount'
import { selectLoggedIn } from 'selectors/accountSelectors'
import { MINIMUM_POINTS_TO_APPLY } from 'loyalty/constants/loyaltyBurn'

function useLoyaltyBurnExperiment() {
  const isLoyaltyEnabled = useAppSelector(getIsLoyaltyEnabled)
  const isLoggedIn = useAppSelector(selectLoggedIn)
  const hasLoyaltyAccount = useAppSelector(getHasLoyaltyAccount)
  const userPoints = useAppSelector(state => state.loyalty.account.data?.points ?? 0)

  const canActivate = isLoyaltyEnabled && (
    !isLoggedIn || (hasLoyaltyAccount && userPoints >= MINIMUM_POINTS_TO_APPLY)
  )

  return useExperiment(Experiments.loyaltySocieteBurn, { canActivate })
}

export default useLoyaltyBurnExperiment
